<mat-icon fontSet="lederplan-ikon-avstemning" class="panel-entitet-ikon mat-icon--lederplan-ikon"/>
<span class="tittel" data-testid="avstemningtittel">{{ manglerStemmegivning().avstemning.tittel }}</span>
<!-- går til møte->sak->avstemning slik at det scrolles til avstemningen i saken, lenken under går kun til møte->sak -->
<button mat-stroked-button color="primary" type="button" (click.stopp)="gaaTilAvstemning()" class="stem-knapp">
  {{ "Stem" | translate }}
</button>
<a (click.stopp)="gaaTilSak()" class="forelder"
   [style.border-left-color]="gruppefarge().rammeFarge"
   matTooltip="{{'sak \"{navn}\" i {gruppe} i {organisasjon}'|translate: {navn: manglerStemmegivning().sakstittel, gruppe: gruppe()?.tittel, organisasjon: gruppe()?.organisasjonsnavn} }}">
  {{ 'tilknyttet sak i {moetetittel} {moetedato}'|translate: {moetetittel: manglerStemmegivning().moetetittel, moetedato: manglerStemmegivning().moeteDatoStart|zoneddatetimeSomPlaindate|plaindate} }}
</a>
